import React, { useEffect, useState } from 'react'
import useApi from '../../hooks/useApi';
import { useNavigate, useParams } from 'react-router-dom';
import Pdf from '../JobPdf/Pdf';
import { pdf } from '@react-pdf/renderer';
import { customStringify, success_alert } from '../../utils';
import { useIntl } from 'react-intl';
import { network_tl } from '../../translations';
import axios from 'axios';
import Loading from "../../components/Loading";
import RetryApi from "../../components/RetryApi";

const GeneratePdfAndSave = () => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const { Axios } = useApi();
    const { id } = useParams();
    const navigate = useNavigate();
    const intl = useIntl();

    const getAndSavePdf = async () => {
        setLoading(true)
        setError(false)
        try {
            const resultPdf = await Axios.get(`api/job/${id}/pdf`)
            if (resultPdf) {
                const data = resultPdf.data.payload;
                const dataPassedPdf = <Pdf data={data} />
                const blob = await pdf(dataPassedPdf).toBlob();
                const formData = new FormData()
                formData.append("file", blob, "file.pdf")
                const result = await Axios.post(`api/job/${id}/pdf`, formData)
                success_alert(result.data.description)
                navigate("/")
            }
        } catch (e) {
            if (axios.isCancel(e)) {

            }
            else if (e.response) {
                setError(customStringify(e.response.data.description))
                setLoading(false)
            } else {
                setError(network_tl(intl))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        getAndSavePdf()
    }, [])
    return (
        <div className="h-screen w-full flex justify-center items-center">
            {
                loading && !error ?
                <Loading />
                : !loading && error ?
                <RetryApi retry={getAndSavePdf} error={error} />
                :
                !loading && !error ?
                null
                :
                null
            }
        </div>
    )
}

export default GeneratePdfAndSave